import { useState } from 'react'
import { Image, Table } from 'react-bootstrap'
import moment from 'moment'
import SpinnerLoading from '../../../spinner-loading'
import { BsCheckCircleFill, BsCircleFill } from 'react-icons/bs'
import ModalCancel from '../ModalCancel'
import UseResignOption from '../../../../hooks/use-resign-option'
import sortDown from '../../../../images/sort-down.svg'
import sortUp from '../../../../images/sort-up-alt.svg'
export default function TableListResignIT({
  dataChecklist,
  page,
  totalLimits,
  isLoading,
  hadleClickIT,
  getChecklistResign,
  sortDoc,
  sortCode,
  sortLastDate,
  sortName,
  handleSortDoc,
  handleSortCode,
  handleSortLastDate,
  handleSortName,
  clickedColumn,
  statusId,
  orgId
}) {
  const [openCancel, setOpenCancel] = useState(false)
  const [detailById, setDetailById] = useState()
  const resignsOption = UseResignOption()

  const onCancel = () => setOpenCancel(false)
  return (
    <>
      <ModalCancel
        fnData={getChecklistResign}
        resignsOption={resignsOption}
        data={detailById}
        open={openCancel}
        onCancel={onCancel}
        page={page}
        statusId={statusId}
      />
      <Table hover className="mb-3">
        <thead
          className="bg-hrms text-white "
          style={{ position: 'sticky', top: '0px', zIndex: 10 }}
        >
          <tr className="font-title-table ">
            <th
              className="fw-normal align-middle"
              style={{ whiteSpace: 'nowrap' }}
            >
              #
            </th>
            <th
              className="fw-normal align-middle"
              style={{ whiteSpace: 'nowrap' }}
            >
              {clickedColumn === 'clrNo' ? (
                <span
                  style={
                    clickedColumn === 'clnNo'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    className="fw-normal"
                    src={sortDoc ? sortDown : sortUp}
                    onClick={() => handleSortDoc('clnNo')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal"
                  src={sortUp}
                  onClick={() => handleSortDoc('clnNo')}
                />
              )}
              Doc No.
            </th>
            <th
              className="fw-normal align-middle"
              style={{ whiteSpace: 'nowrap', minWidth: 50 }}
            >
              {clickedColumn === 'code' ? (
                <span
                  style={
                    clickedColumn === 'code'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    src={sortCode ? sortDown : sortUp}
                    onClick={() => handleSortCode('code')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal"
                  src={sortUp}
                  onClick={() => handleSortDoc('code')}
                />
              )}
              Code
            </th>

            <th
              className="fw-normal align-middle"
              style={{ whiteSpace: 'nowrap', minWidth: 80 }}
            >
              {clickedColumn === 'lastName' ? (
                <span
                  style={
                    clickedColumn === 'lastName'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    src={sortLastDate ? sortDown : sortUp}
                    onClick={() => handleSortLastDate('lastName')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal"
                  src={sortUp}
                  onClick={() => handleSortLastDate('lastName')}
                />
              )}
              Last Date
            </th>

            <th
              className="fw-normal align-middle"
              style={{ whiteSpace: 'nowrap', minWidth: 130 }}
            >
              {clickedColumn === 'name' ? (
                <span
                  style={
                    clickedColumn === 'name'
                      ? {
                          borderRadius: '2px',
                          border: '1px solid black',
                          padding: 2,
                          marginRight: 2
                        }
                      : {}
                  }
                >
                  <Image
                    src={sortName ? sortDown : sortUp}
                    onClick={() => handleSortName('name')}
                  />
                </span>
              ) : (
                <Image
                  className="fw-normal"
                  src={sortUp}
                  onClick={() => handleSortDoc('name')}
                />
              )}
              Name
            </th>

            <th
              className="fw-normal align-middle text-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              Department {/* แผนก */}
            </th>

            <th
              className="fw-normal align-middle"
              style={{ whiteSpace: 'nowrap', minWidth: 140 }}
            >
              Position
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 140 }}
            >
              <div className="fw-normal">01</div>
              <div className="fw-light small">
                <span className="text-danger">ถอน </span>ความพร้อมด้านระบบ
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 140 }}
            >
              <div className="fw-normal">02</div>
              <div className="fw-light small">
                <span className="text-danger">ถอน </span>
                IT Asset
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 140 }}
            >
              <div className="fw-normal">03</div>
              <div className="fw-light small">
                <span className="text-danger">ถอน </span>
                ตั้งค่าเครื่องคอมพิวเตอร์
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 100 }}
            >
              <div className="fw-normal">04</div>
              <div className="fw-light small">
                <span className="text-danger">ถอน </span>ซอฟต์แวร์
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 130 }}
            >
              <div className="fw-normal">05</div>
              <div className="fw-light small">
                <span className="text-danger">ถอน </span>การใช้งานระบบ IT
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 150 }}
            >
              <div className="fw-normal">06</div>
              <div className="fw-light small">
                <span className="text-danger">ถอน </span>
                สิทธิการใช้งานแอปพลิเคชั่น
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 120 }}
            >
              <div className="fw-normal">07</div>
              <div className="fw-light small">
                <div className="fw-light">การตรวจสอบระบบ IT</div>
              </div>
            </th>
            <th
              className="align-middle text-center"
              style={{ whiteSpace: 'nowrap', minWidth: 70 }}
            >
              <div className="fw-normal">08</div>
              <div className="fw-light small">Supervisor</div>
            </th>
            <th
              className="align-middle fw-normal text-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {dataChecklist.length > 0 ? (
            dataChecklist.map((d, i) => (
              <tr key={i} className="fw-light font-small-2 ">
                <td className="">
                  {' '}
                  {page * totalLimits - totalLimits + i + 1}
                </td>
                <td className="">{d.clr_no}</td>
                <td className="">{d.code}</td>

                <td className="text-center">
                  {d.last_date === '0000-00-00' ? (
                    <>-</>
                  ) : (
                    <>
                      {d.last_date
                        ? moment(d.last_date).format('DD/MM/YYYY')
                        : '-'}
                    </>
                  )}
                </td>
                <td className="">
                  <p className="mb-0  ">
                    {d.title_th}
                    {d.name_th} {d.surname_th}
                  </p>
                </td>

                <td className=" text-center">{d.department}</td>

                <td className="">
                  {' '}
                  <p className="mb-0  ">{d.position_th} </p>
                </td>
                {/* 1 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_1 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_1 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_1 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className={`${d.status_id === 3 ? `` : `pointer-event`}`}
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>
                {/* 2 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_2 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_2 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_2 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>

                {/* 3 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_3 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_3 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_3 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>
                {/* 4 */}
                <td className="align-middle text-center">
                  {d.is_confirm4_4 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_4 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_4 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>
                {/* 5 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_5 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_5 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_5 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>
                {/* 6 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_6 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_6 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_6 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>
                {/* 7 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_7 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_7 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#2C5DFE' }} />
                  ) : d.is_confirm4_7 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#adadad' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#2C5DFE' }}
                    />
                  )}
                </td>
                {/* 8 */}
                <td className="text-center align-middle">
                  {d.is_confirm4_8 === 0 && d.status_id === 3 ? (
                    <BsCircleFill size={25} style={{ color: '#adadad' }} />
                  ) : d.is_confirm4_8 === 1 && d.status_id === 3 ? (
                    <BsCheckCircleFill size={25} style={{ color: '#FFC107' }} />
                  ) : d.is_confirm4_8 === 0 ? (
                    <BsCircleFill
                      size={25}
                      style={{ color: '#FFC107' }}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                    />
                  ) : (
                    <BsCheckCircleFill
                      size={25}
                      onClick={() => hadleClickIT(d)}
                      className="pointer-event"
                      style={{ color: '#FFC107' }}
                    />
                  )}
                </td>
                <td
                  className={`text-center align-middle ${
                    d.status_id === 1
                      ? 'text-warning'
                      : d.status_id === 2
                        ? 'text-success'
                        : d.status_id === 3
                          ? 'text-danger'
                          : null
                  }`}
                >
                  {d.status_en}
                </td>
              </tr>
            ))
          ) : !orgId ? (
            <tr className="mb-0">
              <td className="text-center small" colSpan={13}>
                - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
              </td>
            </tr>
          ) : isLoading ? (
            <tr className="mb-0">
              <td className="text-center align-middle" colSpan={16}>
                <SpinnerLoading />
              </td>
            </tr>
          ) : (
            <tr className="mb-0">
              <td className="text-center" colSpan={16}>
                -ไม่มีข้อมูล-
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  )
}
